export const lovet = {
	PAGE_THEME_ENABLED: false,
};
